import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';
import { TwtEditingType } from '~/tenants/twt/performable/editing/TwtEditingConfig';

/**
 * "Request Edits" on a delivered order (the agent's Deliverables page): the
 * same edit menu, form and prices as Twist's (TwtEditingConfig), so the sales
 * demo shows what a Twist agent sees.
 */
export default createPerformableConfig(
  'editing',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      images: z
        .array(
          z.object({
            type: z.nativeEnum(TwtEditingType),
            deliverable_id: z.string(),
            job_id: z.string().optional(),
            notes: z.string().optional(),
          }),
        )
        .min(1, 'Please select at least one image.'),
    }),
  },
  {
    name: 'Photo Editing',
    short: '',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
